import { RETRIEVEEXPENSE_SUCCESS, RETRIEVEEXPENSE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const retrieveExpenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case RETRIEVEEXPENSE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case RETRIEVEEXPENSE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default retrieveExpenseReducer;
